import React from "react";
import { Field, Form } from "react-final-form";
import { useSelector } from "react-redux";
import InputField from "../../General-UI/InputField";
import { CONFIRM_CODE_LENGTH } from "constants/constants";
import {
  selectRegisterError,
  selectSuccessRegister,
  selectTryingRegister,
  selectUserPending,
  confirmRegister,
  signIn,
  setUser,
} from "slices/authSlice";
import TickIcon from "graphics/icons/TickIcon";
import history from "constants/history";
import { setConfirmPicAction } from "slices/createPictureSlice";

const validate = (formValues) => {
  const errors = {};
  if (!formValues.code) {
    errors.code = "Enter Your Code To Confirm";
  } else if (formValues.code.length !== 6) {
    errors.code =
      "The code sent is " + CONFIRM_CODE_LENGTH.toString() + " digits long";
  }

  return errors;
};

const parseCode = (value) => {
  if (!value) {
    return value;
  }
  return value.slice(0, 6);
};

const CodeConfirm = ({ postCreate }) => {
  const tryingRegister = useSelector(selectTryingRegister);
  const registerError = useSelector(selectRegisterError);
  const userPending = useSelector(selectUserPending);
  const successRegister = useSelector(selectSuccessRegister);
  return (
    <div className="inline-form">
      <div className="confirmed-email">
        <span>{userPending ? userPending.username : null}</span>
        <div className="svg-tick">
          <TickIcon />
        </div>
      </div>

      <div className="modal-text">
        Enter the verification code sent to your email:
      </div>
      <div className="modal-text-small">Can't find it? Check junk mail</div>
      <div className="text-center">
        <Form
          onSubmit={async (formValues) => {
            if (userPending) {
              let deets = await confirmRegister(
                userPending.username,
                formValues.code
              );
              if (!deets) return;
              let user = await signIn(deets.username, deets.password);
              setUser(user)
                .then(() => {
                  history.push("/createPicture");
                  setConfirmPicAction(postCreate);
                })
                .catch(() => {
                  window.efs_debug &&
                    window.log("Could not set user from sign in");
                });
            }
          }}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <Field
                  name="code"
                  type="number"
                  parse={parseCode}
                  component={InputField}
                  placeholder="123456"
                  className="input-box verify-code-input"
                  liveCheck={true}
                />
              </div>
              {!successRegister ? (
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="confirm-button growth-button mt-1"
                  disabled={tryingRegister}
                >
                  {tryingRegister ? "Verifying..." : "Complete"}
                </button>
              ) : (
                <div className="success-register">
                  Account Registered! Redirecting...
                </div>
              )}

              <div className="server-response-error">
                {registerError ? registerError.message : null}
              </div>
            </form>
          )}
        />
      </div>
    </div>
  );
};

export default CodeConfirm;
